import customAxios from "../index";
import qs from "qs";

export const getPreneedBookingAppointmentLeads = (params?: {
  limit?: number;
  offset?: number;
  page?: number;
  pageSize?: number;
}) => {
  return customAxios({
    method: "GET",
    url: `/planner-dashboard/booking-appointment/leads`,
    params,
  });
};

export const getPreneedBookingAppointmentLeadById = (leadId: number) => {
  return customAxios({
    method: "GET",
    url: `/planner-dashboard/booking-appointment/leads/details/${leadId}`,
    // headers: token
    //   ? {
    //     Authorization: `Bearer ${token}`,
    //     source: "AFH",
    //     "x-user-type": "preNeed",
    //   }
    //   : {
    //     source: "AFH",
    //     "x-user-type": "preNeed",
    //   },
  });
};
export const updateLeadDataById = (leadId: number, data: any) => {
  return customAxios({
    method: "PUT",
    url: `/planner-dashboard/booking-appointment/leads/${leadId}`,
    data,
  });
};
export const sendQuotationToPreneedLead = (leadId: number, data: {
  packageIds: number[];
}) => {
  return customAxios({
    method: "POST",
    url: `/planner-dashboard/booking-appointment/leads/${leadId}/send-quotation`,
    data,
  });
};

export const bookPackageForLead = (
  leadId: number,
  data: { packageId: number; serviceDate: string }
) => {
  return customAxios({
    method: "POST",
    url: `/planner-dashboard/booking-appointment/leads/${leadId}/book-package`,
    data,
  });
};

export const getPreneedPackages = () => {
  return customAxios({
    method: "GET",
    url: `/planner-dashboard/service-package`,
  });
};
export const getPreneedBookingRequests = (params: any) => {
  return customAxios({
    method: "GET",
    url: "/planner-dashboard/booking-appointment",
    params,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  });
};
export const deletePreneedPlannerUploadedDocument = (documentId: number | string) => {
  return customAxios({
    method: "DELETE",
    url: `/planner-dashboard/profile-management/delete-documents/${documentId}`,
  });
}